import { Endereco } from './../../modelos/endereco';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-endereco',
  templateUrl: './form-endereco.component.html',
  styleUrls: ['./form-endereco.component.css']
})
export class FormEnderecoComponent implements OnInit {

  @Input() endereco: Endereco;
  @Input() modo: string;

  @Output() enderecoEvent: EventEmitter<string>;

  public cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

  constructor() {
    this.enderecoEvent = new EventEmitter<string>();
  }

  ngOnInit() {
  }

  emit(): void {
    this.enderecoEvent.emit('formulário completo');
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/form-endereco/form-endereco.component.ts